import {Avatar, Box, Button, Card, Chip, Grid, Stack, Typography} from "@mui/joy";
import {appRoute} from "../../../utils/routes";
import React from "react";
import {CheckCircle} from "lucide-react";
import {formatTimeFromSeconds} from "../../../utils/formatTime";
import {motion} from "motion/react"
import {Link, useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";

type TestCompletedComponentProps = {
    questions?: number,
    answered?: number,
    timeUsed?: number,
    onGoBack?: () => void
}

const TestCompletedComponent = (props: TestCompletedComponentProps) => {
    const navigate = useNavigate()
    const {t} = useTranslation()
    const handleGoBack = () => {
        navigate(-1)
    }

    return <Stack gap={3}>
        <Card data-no-animation data-no-glow
              sx={{paddingX: 5, paddingY: 3, gap: 3, alignSelf: "center", marginTop: 4, alignItems: "center"}}>
            <motion.div
                initial={{y: 0}}
                animate={{y: [0, 20, 0]}}
                transition={{
                    duration: 3,
                    repeat: Infinity,
                    ease: "linear"
                }}
                style={{alignSelf: "center"}}>
                <Box borderRadius={100} className={"glow-bg"}
                     sx={{
                         '--Avatar-size': "70px",
                         backgroundColor: "success.400",
                         width: 80,
                         height: 80,
                         alignItems: "center",
                         justifyContent: "center",
                         display: "flex",
                         color: 'white'
                     }} color={"success"}>
                    <CheckCircle style={{fontSize: 48, color: "inherit"}}/>
                </Box>
            </motion.div>

            <Stack alignItems={"center"} gap={1}>
                <Typography level={"h4"}>
                    {t("testCompletedTitle")}
                </Typography>

                <Typography level={"body-sm"}>
                    {t("testCompletedDescription")}
                </Typography>
            </Stack>

            <Stack gap={2} direction={"row"} alignItems={"center"}>

                <Grid container spacing={1.5}>

                    <Grid xs={6} sm={3}>
                        <Card data-no-animation data-no-glow sx={{alignItems: "center", paddingX: 4}}>
                            <Typography level={"body-sm"}>
                                {t("testQuestionsLabel")}
                            </Typography>
                            <Typography level={"title-lg"}>
                                {props.questions}
                            </Typography>
                        </Card>
                    </Grid>

                    <Grid xs={6} sm={3}>
                        <Card data-no-animation data-no-glow sx={{alignItems: "center", paddingX: 4}}>
                            <Typography level={"body-sm"}>
                                {t("answeredQuestionLabel")}
                            </Typography>
                            <Typography level={"title-lg"}>
                                {props.answered}
                            </Typography>
                        </Card>
                    </Grid>

                    <Grid xs={12} sm={6}>
                        <Card data-no-animation data-no-glow sx={{alignItems: "center", paddingX: 4}}>
                            <Typography level={"body-sm"}>
                                {t("timeUsedLabel")}
                            </Typography>
                            <Typography level={"title-lg"}>
                                {formatTimeFromSeconds(props.timeUsed)}
                            </Typography>
                        </Card>
                    </Grid>
                </Grid>

            </Stack>


            <Stack gap={3} direction={"row"} alignItems={"center"}>
                <Button onClick={handleGoBack} color={"neutral"} size={"lg"} variant={"outlined"}>
                    Return
                </Button>

                <Link to={appRoute()}>
                    <Button size={"lg"}>
                        Go to Dashboard
                    </Button>
                </Link>
            </Stack>

        </Card>


    </Stack>
}

export default TestCompletedComponent